import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import FieldIcon from '@atlaskit/icon/core/field';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.generic-field.icon-label',
		defaultMessage: 'Generic field icon',
		description:
			'Accessible label for the icon used as a fallback for unrecognized field types in a Jira work item action card.',
	},
});

export function GenericFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<FieldIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
